import { Navigate, Outlet } from "react-router-dom";

export default function ProtectedRoute() {
  return localStorage.getItem("user") ? <Outlet /> : <Navigate to="/login" />;
}
